export function sortString(data: any[], key: string, order: "ASC" | "DESC") {
  return data.sort((a, b) => {
    const aVal = a[key] ?? ""
    const bVal = b[key] ?? ""
    return order === "ASC" ? String(aVal).localeCompare(bVal) : String(bVal).localeCompare(aVal)
  })
}

export function sortNumber(data: any[], key: string, order: "ASC" | "DESC") {
  return data.sort((a, b) => {
    const aVal = a[key] ?? 0
    const bVal = b[key] ?? 0
    return order === "ASC" ? aVal - bVal : bVal - aVal
  })
}
export function sortBoolean(data: any[], key: string, order: "ASC" | "DESC") {
  return data.sort((a, b) => {
    const aVal = Number(a[key]) ?? 0
    const bVal = Number(b[key]) ?? 0
    return order === "ASC" ? aVal - bVal : bVal - aVal
  })
}
export function sortDate(data: any[], key: string, order: "ASC" | "DESC") {
  return data.sort((a, b) => {
    const aVal = a[key] ? new Date(a[key]).valueOf() : 0
    const bVal = b[key] ? new Date(b[key]).valueOf() : 0
    return order === "ASC" ? aVal - bVal : bVal - aVal
  })
}

export function sortFnString<T>(data: T[], itemFn: (item: T) => string, order: "ASC" | "DESC") {
  return data.sort((a, b) => {
    const aVal = itemFn(a)
    const bVal = itemFn(b)
    return order === "ASC" ? String(aVal).localeCompare(bVal) : String(bVal).localeCompare(aVal)
  })
}

export function sortFnNumber<T>(data: T[], itemFn: (item: T) => number, order: "ASC" | "DESC") {
  return data.sort((a, b) => {
    const aVal = Number(itemFn(a)) ?? 0
    const bVal = Number(itemFn(b)) ?? 0
    return order === "ASC" ? aVal - bVal : bVal - aVal
  })
}
